import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Top1 from "../Images/top1.png";
import Top2 from "../Images/top2.png";
import Top3 from "../Images/top3.png";

function Topconnection() {
  const [activeTab, setActiveTab] = useState("Integrated-Google");

  const tabs = [
    { key: "Integrated-Google", label: "Integrated Google tools", image: Top3 },
    { key: "Analyse-Keywords", label: "Analyse Keywords", image: Top2 },
    { key: "Structure-data", label: "Structure data", image: Top1 },
    { key: "Social-media", label: "Integrated Social Media", image: Top1 },
  ];

  return (
    <section className="top-tabs-wrapper">
      {/* Tabs */}
      <div className="d-flex gap-3 flex-wrap justify-content-center py-3 bg-white shadow-sm mb-5">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`btn ${
              activeTab === tab.key ? "text-dark" : "btn-outline-secondary"
            }`}
            style={
              activeTab === tab.key
                ? {
                    background:
                      "linear-gradient(to right, rgb(175, 221, 255) 0%, rgb(197, 231, 255) 30%, rgb(218, 240, 255) 60%, rgb(237, 248, 255) 85%, rgb(255, 255, 255) 100%)",
                    border: "1px solid #aad4f4",
                    fontWeight: "500",
                  }
                : {}
            }
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-content-wrapper text-center p-4">
        {tabs.map(
          (tab) =>
            activeTab === tab.key && (
              <img
                key={tab.key}
                src={tab.image}
                alt={tab.label}
                className="img-fluid"
                style={{ maxHeight: "500px", objectFit: "contain" }}
              />
            )
        )}
      </div>
    </section>
  );
}

export default Topconnection;
